// Gemeenschappelijke maten, kleuren en datumhulp voor de jaarplanning
export const LABEL_W = 62;
export const STAT_W = 96;
export const HEAD_H = 46;

export const MONTHS = {
  nl: ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"],
  en: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  es: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
};

export const COLORS = {
  ".": { bg: "linear-gradient(180deg,#ffffff,#f1f6fc)", ring: "rgba(148,180,210,.65)", glow: "rgba(96,140,190,.35)", ribbon: false },
  R: { bg: "linear-gradient(180deg,#fcd34d,#f59e0b 55%,#d97706)", ring: "rgba(120,53,15,.5)", glow: "rgba(245,158,11,.75)", ribbon: false },
  r: { bg: "linear-gradient(180deg,#fde68a,#fbbf24 55%,#f59e0b)", ring: "#7f1d1d", glow: "rgba(245,158,11,.8)", ribbon: true },
  B: { bg: "linear-gradient(180deg,#fb7185,#e11d48 55%,#be123c)", ring: "rgba(76,5,25,.55)", glow: "rgba(244,63,94,.8)", ribbon: false },
  b: { bg: "linear-gradient(180deg,#fecdd3,#fb7185 55%,#f43f5e)", ring: "#7f1d1d", glow: "rgba(244,63,94,.85)", ribbon: true },
  O: { bg: "linear-gradient(180deg,#e2e8f0,#cbd5e1 55%,#b6c2d1)", ring: "rgba(71,85,105,.5)", glow: "rgba(100,116,139,.45)", ribbon: false },
  o: { bg: "linear-gradient(180deg,#e2e8f0,#cbd5e1 55%,#b6c2d1)", ring: "#7f1d1d", glow: "rgba(100,116,139,.45)", ribbon: true },
  X: { bg: "repeating-linear-gradient(45deg,#94a3b8 0 4px,#64748b 4px 8px)", ring: "rgba(30,41,59,.6)", glow: "rgba(100,116,139,.5)", ribbon: false },
};

export const addDays = (iso, n) => {
  const d = new Date(`${iso}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
};
